export default __webpack_public_path__ + "static/apprightplain-bcf895420227ea2e59c9e53b66156f9c.svg";